import { httpGet } from "@/api/connection";
import {
  EvidenceStatusIcon,
  GetEvidenceStatusFn,
  GetEvidenceStatusResponse,
} from "./evidence-status.types";
import { EVIDENCE_STATUSES } from "./EvidenceStatuses";

const getEvidenceStatus: GetEvidenceStatusFn = async (values) => {
  const { id } = values || {};
  let data: GetEvidenceStatusResponse = {
    data: [],
  };

  if (id === undefined) {
    data = await httpGet("/evidence-status");
  } else {
    data = await httpGet(`/evidence-status/${id}`);
  }

  data.data = data.data.map((status) => {
    const baseStatus = EVIDENCE_STATUSES.find(
      (s) => s.status_id === status.status_id
    );
    return {
      ...status,
      color: baseStatus?.color || "#9e9e9e",
      icon: baseStatus?.icon || EvidenceStatusIcon.CircleDashed,
    };
  });

  return data;
};

export const EvidenceStatusAPI = {
  get: getEvidenceStatus,
};
